import React from 'react';
import { Typography, List, ListItem, ListItemText, Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const BodyTab = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box>
            <Typography variant="h6" gutterBottom>Request Body Types</Typography>
            <List>
                <ListItem>
                    <ListItemText primary="JSON" secondary="Structured JSON data for APIs" />
                </ListItem>
                <ListItem sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                    <ListItemText primary="GraphQL" secondary="Send GraphQL queries and mutations with schema fetch and auto-complete query suggestions functionality" />
                    <img
                        src="/send-requests/GraphQL.png"
                        alt="Validations in HawkClient"
                        style={{
                            width: isMediumScreen ? '100%' : '60%',
                            height: 'auto',
                            display: 'block',
                            objectFit: 'contain',
                            marginTop: '16px',
                            alignSelf: 'start',
                        }}
                    />
                </ListItem>
                <ListItem>
                    <ListItemText primary="form-data" secondary="Used for file uploads or key-value pairs" />
                </ListItem>
                <ListItem>
                    <ListItemText primary="x-www-form-urlencoded" secondary="URL-encoded key-value pairs" />
                </ListItem>
                <ListItem>
                    <ListItemText primary="Text" secondary="Plain text content" />
                </ListItem>
                <ListItem>
                    <ListItemText primary="XML" secondary="Send raw XML payloads" />
                </ListItem>
            </List>
        </Box>
    )
};

export default BodyTab;
